import { Box } from "@mui/material";
import { Suspense, lazy, useEffect } from "react";
import { useSelector } from "react-redux";
import { SectionHeader, Spinner } from "../../../components/exports";
import { RootState } from "../../../slices/Store";
import ProjectDetailAddress from "../Shared/ProjectDetailAddress";
import ProjectDetailConstructor from "../Shared/ProjectDetailConstructor";
import ProjectDetailFolders from "../Shared/ProjectDetailFolders";
import ProjectDetailInfo from "../Shared/ProjectDetailInfo";
import ProjectDetailInvalidDataAndVisibility from "../Shared/ProjectDetailInvalidDataAndVisibility";
import ProjectDetailNotes from "../Shared/ProjectDetailNotes";
import ProjectDetailSales from "../Shared/ProjectDetailSales";
import ProjectDetailViewConstructor from "../Shared/ProjectDetailViewConstructor";
import ProjectDetailMobileHeader from "./ProjectDetailMobileHeader";
import ProjectDetailMobilePhotos from "./ProjectDetailMobilePhotos";
import ProjectDetailMobileSms from "./ProjectDetailMobileSms";

const ProjectDetailMap = lazy(() => import("../Shared/ProjectDetailMap"));

// updated
export default function ProjectDetailMobileDialog(props: {
    selectedFollowUpId?: number;
    openSales?: boolean;
}) {
    const projectDetailState = useSelector(
        (state: RootState) => state.projectDetail
    );

    const scrollToSectionIfNeeded = () => {
        if (props.openSales) {
            const section = document.querySelector("#sales_section");
            if (section) {
                section.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }
    };

    useEffect(() => {
        scrollToSectionIfNeeded();
    }, []);

    if (projectDetailState.fetchingProjectDetail) {
        return <Spinner />;
    }

    return (
        <Box sx={{ bgcolor: "background.default" }}>
            <ProjectDetailMobileHeader />

            <Box sx={{ p: 2 }}>
                <ProjectDetailMobilePhotos />

                <ProjectDetailViewConstructor />

                <ProjectDetailConstructor />

                {/*<ProjectDetailRequirements/>*/}

                <ProjectDetailAddress />

                <ProjectDetailInfo />

                <ProjectDetailInvalidDataAndVisibility />

                <ProjectDetailFolders />

                <Box id="sales_section">
                    <SectionHeader title="فرایند های فروش" />
                    <ProjectDetailSales />
                </Box>

                <Box>
                    <SectionHeader title="یادداشت ها" />
                    <ProjectDetailNotes />
                </Box>

                <Box>
                    <SectionHeader title="موقعیت پروژه" />
                    <Suspense fallback={<Spinner />}>
                        <ProjectDetailMap />
                    </Suspense>
                </Box>

                <ProjectDetailMobileSms
                    projects={[projectDetailState.projectDetail]}
                />
            </Box>
        </Box>
    );
}
